module.exports = "<app-welcomet></app-welcomet>\r\n<app-plenary-speakers></app-plenary-speakers>\r\n<app-scientific-comittee></app-scientific-comittee>\r\n<app-organizers></app-organizers>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main